import React, { useContext } from "react";
import { Portal } from "react-overlays";
import { useSelector } from "react-redux";
import { mainPage as mainPageSelector } from "../util/selectors";
import { PageHeaderContext } from "./MainPageContainer";
export const MainPageHeader = ({ children }) => {
    const mainPage = useSelector(mainPageSelector);
    const { headerPortal, page } = useContext(PageHeaderContext);
    if (!headerPortal?.()) {
        return null;
    }
    return mainPage === page ? (React.createElement(Portal, { container: headerPortal },
        React.createElement("div", { className: "mainpage-header" }, children))) : null;
};
export default MainPageHeader;
